/* eslint-disable global-require */
module.exports = require('./store')
